import * as React from "react";
import DataImage from "../../DataImage";
import {IFoodBanksProps} from "../../utils/models";
import makeSum from "../../../../utils/makeSum";
import image from '../../asset/1. Food Banks.png'

const FoodBanks = ({ submissions }: IFoodBanksProps) => {
    return (
        <DataImage
            image={image}
            value={makeSum(submissions, 'total_number_of_food_banks')}
            text="Total Number of Food Banks"
        />
    );
}

export default FoodBanks;